import { Loader2 } from "lucide-react";
import AdminHeader from "@/components/common/AdminHeader";
import PickupsScreen from "@/components/branch-incharge/screens/PickupsScreen";
import PermissionGuard from "@/components/common/PermissionGuard";
import DeliveryPickupsComponent from "@/components/delivery/DeliveryPickups";
import { useRoleContext } from "@/hooks/useRoleContext";
import { useBranchInfo } from "@/hooks/useBranchInfo";

export default function DeliveryPickupsPage() {
  const { isBranchIncharge, isZoneManager } = useRoleContext();
  // const { branchInfo, loading } = useBranchInfo();

  // if (isBranchIncharge || isZoneManager) {
  //   return (
  //     <div className="min-h-screen bg-gray-50">
  //       <AdminHeader />
  //       <main className="max-w-full mx-auto px-6 py-8">
  //         {loading || !branchInfo ? (
  //           <div className="flex items-center justify-center py-32">
  //             <Loader2 className="w-6 h-6 animate-spin text-brand-500 mr-2" />
  //             <p className="text-gray-500">Loading…</p>
  //           </div>
  //         ) : (
  //           <PermissionGuard screen="pickups">
  //             <PickupsScreen branchInfo={branchInfo} />
  //           </PermissionGuard>
  //         )}
  //       </main>
  //     </div>
  //   );
  // }

  return <DeliveryPickupsComponent />;
}
